export enum SmartfeedActivityType {
  SHOW_ALL = 'Show All',
  CUST_VIEW = "Customer's View",
  DISCONNECT = 'Disconnects',
  ERROR = 'Errors',
  FEEDER_STATUS = 'Feeder Status',
  FEEDERS = 'Feeders',
}

export enum SmartfeedMessageType {
  FEED_DONE = 'Feed Done',
  FOOD_GOOD = 'Food Good',
  FOOD_LOW = 'Food Low',
  FOOD_HIGH = 'Food High',
  FOOD_UNKNOWN = 'Food Unknown',
  WILL_MESSAGE = 'Will Message',
  OTA_TASK_UPGRADE_STARTED = 'OTA Task Upgrade Started',
  SHUTDOWN = 'Shutdown',
  FOOD_SENSOR = 'Food Sensor',
  SCHEDULE_SETTINGS = 'Schedule Settings',
  STATUS = 'Status',
  FEED_ERROR_MOTOR_SWITCH = 'Feed Error Motor Switch',
  FEED_ERROR_MOTOR_CURRENT = 'Feed Error Motor Current',
  OTA_TASK_UPGRADE_FAILED = 'OTA Task Upgrade Failed',
}
